import { defineComponent, reactive, ref, toRefs, computed, onMounted, onBeforeUnmount, getCurrentInstance, nextTick } from 'vue';
export default defineComponent({
  emits: ['scroll'],
  setup(_, context) {
    // 1. 修正：给 ref 添加强类型，指向 ElScrollbar 组件实例
    const scrollContainerRef = ref(null);
    // 2. 修正：scrollWrapper 计算属性返回 HTMLElement | null，避免 undefined
    const scrollWrapper = computed(() => {
      // 确保 scrollContainerRef 存在，再获取内部的 wrap 元素
      if (!scrollContainerRef.value) return null;
      return scrollContainerRef.value.$refs.wrap;
    });
    // 3. 修正：废弃 ctx，改用 proxy（getCurrentInstance 推荐用法）
    const instance = getCurrentInstance();
    const proxy = instance?.proxy; // 父组件上下文（谨慎使用，优先通过 props/emit 通信）
    const tagSpacing = 4;
    const state = reactive({
      // 滚动事件处理（水平滚动）
      handleScroll: e => {
        const wrapper = scrollWrapper.value;
        if (!wrapper) return; // 避免 undefined 调用
        // 计算滚动距离（兼容不同浏览器的 wheel 事件）
        const eventDelta = e.wheelDelta || -e.deltaY * 40;
        wrapper.scrollLeft = wrapper.scrollLeft + eventDelta / 4;
      },
      // 滚动到当前标签
      moveToCurrentTag: currentTag => {
        const wrapper = scrollWrapper.value;
        const container = scrollContainerRef.value?.$el;
        if (!wrapper || !container) return; // 前置判断，避免 undefined
        // 修正：通过 proxy 获取父组件的 tag 列表，且添加存在性判断
        const tagList = proxy?.$parent?.$refs.tag;
        if (!tagList || tagList.length === 0) return;
        const fristTag = tagList[0];
        const lastTag = tagList[tagList.length - 1];
        const containerWidth = container.offsetWidth;
        // 滚动到第一个标签
        if (fristTag === currentTag) {
          wrapper.scrollLeft = 0;
          return;
        }
        // 滚动到最后一个标签
        if (lastTag === currentTag) {
          wrapper.scrollLeft = wrapper.scrollWidth - containerWidth;
          return;
        }
        // 滚动到中间标签（需确保前后标签存在）
        const currentIndex = tagList.findIndex(item => item === currentTag);
        if (currentIndex === -1) return; // 未找到当前标签，直接返回
        const prevTag = tagList[currentIndex - 1];
        const nextTag = tagList[currentIndex + 1];
        if (!prevTag || !nextTag) return; // 前后标签不存在，避免 undefined
        // 计算滚动位置
        const afterNextTagOffsetLeft = nextTag.offsetLeft + nextTag.offsetWidth + tagSpacing;
        const beforePrevTagOffsetLeft = prevTag.offsetLeft - tagSpacing;
        if (afterNextTagOffsetLeft > wrapper.scrollLeft + containerWidth) {
          wrapper.scrollLeft = afterNextTagOffsetLeft - containerWidth;
        } else if (beforePrevTagOffsetLeft < wrapper.scrollLeft) {
          wrapper.scrollLeft = beforePrevTagOffsetLeft;
        }
      }
    });
    // 触发父组件的 scroll 事件
    const emitScroll = () => {
      context.emit('scroll');
    };
    // 4. 核心修复：确保 scrollWrapper 存在后再绑定事件
    onMounted(() => {
      // 用 nextTick 等待 el-scrollbar 内部元素完全渲染（关键！）
      nextTick(() => {
        const wrapper = scrollWrapper.value;
        if (wrapper) {
          // 确认元素存在，再绑定事件
          wrapper.addEventListener('scroll', emitScroll, true);
        }
      });
    });
    // 5. 修复：解绑事件前也需判断元素是否存在，避免内存泄漏和错误
    onBeforeUnmount(() => {
      const wrapper = scrollWrapper.value;
      if (wrapper) {
        wrapper.removeEventListener('scroll', emitScroll);
      }
    });
    return {
      scrollContainerRef,
      ...toRefs(state)
    };
  }
});